import { mount } from '../boot.js';
import { CryptoTicker } from './CryptoTicker.js';

mount(CryptoTicker);
